import { QuoteResponse } from "@vertical-insure/shared";

const addMetadataFields = (quote: QuoteResponse) => {
  const fields = [];
  if (quote.metadata?.context_description) {
    fields.push(quote.metadata?.context_description);

  } else {
    if (quote.metadata?.context_name) {
      fields.push(quote.metadata?.context_name);
    }

    if (quote.metadata?.context_event) {
      fields.push(quote.metadata?.context_event);
    }
  }

  let value = ''
  if (fields.length > 0) {
    value = `(${fields.join(' - ')})`
  }
  return value;
}

export const QuoteActionDescription = ({product, quote }:{product: string, quote: QuoteResponse}) => {
  switch(product) {
    case "gap-medical":
      return (
        <>
          Include <span className="capitalize font-medium">{quote.policy_attributes['coverage_type']?.toLowerCase()}</span> package for {quote.policy_attributes['covered_person']['first_name']} {quote.policy_attributes['covered_person']['last_name']}
        </>
      );
    case "registration-cancellation":
    case "season-interruption": 
      return (
        <>
          Accept coverage for {quote.policy_attributes['participant']['first_name']} {quote.policy_attributes['participant']['last_name']} {addMetadataFields(quote)}
        </>
      );
    case "team-registration":
      return (
        <>
          Include coverage for team(s): {quote.policy_attributes['teams'].map((t: { team_name: string; }) => t.team_name).join(", ")}
        </>
      )
    case "event-host-liability":
    case "event-host-liability-rental-coverage":
      return (
        <>
          Accept coverage for my event
        </>
      )
    case "ticket-refund":
      return (
        <>
          Accept coverage {quote.metadata?.context_event ? `for ${quote.metadata?.context_event}` : ''}
        </>
      );
    default: 
      return <></>;
  }
}
